import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

class ErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch = (error) => {
    this.setState({ hasError: true });
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorWrapper>
          <h4>
            An error has occurred, please contact GraVoc Support at
            <a href="mailto:support@gravoc.com"> support@gravoc.com</a>
          </h4>
        </ErrorWrapper>
      );
    }
    return this.props.children;
  }
}

ErrorHandler.propTypes = {
  children: PropTypes.node
};
const ErrorWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 50px;
`;

export default ErrorHandler;
